var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
/**
 * Get the mime type from a base 64 encoded image
 * @param base64 Base64 encoded string of an image
 * @returns the mime type of the encoded image
 */
function getBase64MimeType(base64) {
    const mime = base64.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
    if (mime && mime.length) {
        return mime[1];
    }
    return null;
}
/**
 * Converts a base64 string into a File object
 * @param base64 Base64 encoded image
 * @returns File object
 */
export function getFileFromDataUrl(base64) {
    return fetch(base64)
        .then(res => res.blob())
        .then(blob => new File([blob], "uploaded-file", { type: getBase64MimeType(base64) || undefined }));
}
/**
 * Get the size of a base64 encoded file in bytes
 * @param base64 Base64 encoded file
 * @returns The file size in bytes
 */
export function getFileSize(base64) {
    return (base64.length * 0.75) - (base64.substr(-2) == '==' ? 2 : 1);
}
/**
 * Upload a user image to the server for use in visualisation
 * @param base64 Base64 encoded image string
 * @returns File name of the uploaded image
 */
export function uploadUserImage(base64) {
    return __awaiter(this, void 0, void 0, function* () {
        const uploadLocation = '/api/frameDesigner/uploadImage';
        const formData = new FormData();
        const file = yield getFileFromDataUrl(base64);
        formData.append('file', file);
        const { data } = yield axios
            .post(uploadLocation, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return data.filename;
    });
}
